<template>
  <div id="menu">
    <div id="sm-menu">
      <img v-on:click="closeMenu()" src="../assets/close.png" id="close" alt="オンライン専門ZOOMコンパニオン「ズムコン！」">
      <ul>
       <a href="/"><li class="hover">トップページ</li></a>
        <a href="/menu"><li class="hover">料金システム</li></a>
        <a href="/companion"><li class="hover">コンパニオン</li></a>
        <a href="/service"><li class="hover">サービス紹介</li></a>
        <a href="/contact"><li class="hover">お問い合わせ</li></a>
      </ul>
    </div>
    <SubHeader/>
    <div class="top">
    <p class="subTitle-row">サービス内容</p>
    </div>
    <div class="card-contents">
    <div class="flexbox">
  <section class="main">
    <p class="title">ケイプロモーションが<br class="sm-br">お送りする<br>オンライントークルーム</p>
    <p class="description">本サービスは現役イベントコンパニオンと<br>ZOOMを通しおしゃべりしたり、一緒に飲食できるサービスです。<br>暇つぶしのお話相手に、実は知りたいコパにオン事情<br>いつもは綺麗なユニフォームのコンパニオンも<br>実は１：１だと素人女子です。<br>いつもはたくさんの方々に笑顔でお声がけしてますが<br>緊張しちゃうかも知れません。<br>お客様を笑顔にする事がモットーのコンパニオンが<br>全力でお客様と宅飲みトーーークします。<br>お試しコース10分からでも楽しいで見てください。</p>
  </section>
  <section class="side">
    <img src="../assets/companion.jpeg" alt="ズームコンパ">
  </section>
</div>
  </div>
   <div class="reserve-button-wrap">
    <a class="reserve-button" href="https://coubic.com/kei-corporation/943293#pageContent" target="_blank">予約はこちら</a>
    </div>
  </div>
</template>
<style scoped>
.subTitle-row{
 background-image: url(../assets/bg-title.jpg);
background-size:cover;
  height: 50px;
  line-height: 50px;
 color:white;
 box-shadow: 4px 4px #005FFF;
  width: 70%;
  margin:36px auto;
  font-size:24px;
  border-radius: 5px 5px 5px 5px;
  font-weight: bold;
  border: 5px solid  white;
}
.reserve-button{
background-color:#FFA07A;
  padding: 8px;
  width: 400px;
  font-size: 36px;
  border-radius: 30px;
  color: white!important;
}
.reserve-button-wrap{
  margin: 5%;
}
.reserve-button-wrap a{
  text-decoration: none;
  color: white;
}
.reserve-button-wrap a:hover{
  background-color:#FF8C00;
}
.card-contents{
   background-color: white;
   box-shadow: 4px 4px #006600;
  width: 70%;
  margin: 36px auto;
  text-align: center;
}
.sm-br{
  display: none;
}
.main {
  margin-bottom: 10px;
  width: 60%;
}
.side {
  width: 40%;
   position: relative;
}
.side img{
  width: 350px;
  position: absolute;
  left: 0px;
  top:25%;
  border-radius: 10px 10px 10px 10px;
}
.card-contents .title{
  display: table;
  background-color: #006600;
  font-size:24px;
  color: white;
  margin-left: 36px;
  padding-left: 8px;
  padding-right: 8px;
  font-weight: bold;
}
.card-contents .description{
  text-align: left;
  font-size:18px;
  color: #555555;
  margin-left: 36px;
  line-height: 36px;
  font-weight: bold;
}
.main,
.side {
  padding: 2%;
  border-radius: 10px
}
.top{
  padding-top: 0px;
}

/* Responsive */
@media ( min-width : 600px ){
    .flexbox {
      display: -webkit-flex;
      display: flex;
    }
  .main {
    margin: 0 10px 0 0;
  }
}
#sm-menu{
  background-color:rgba(0,0,0,0.9);
  display: none;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: black;
  position: fixed;
}
#close{
display: block;
position: absolute;
width: 64px;
height:64px;
top:16px;
right:16px;
}
@media ( max-width : 680px ){
  .card-contents{
  width: 90%;
  height: 1000px;
}
.top{
  padding-top: 100px;
}
a{
    color: #555555!important;
   font-weight: bold;
  text-decoration: none;
  font-size:24px;
}
.sm-br{
  display: block;
}
  #sm-menu li{
    display: block;
   background-image: url(../assets/bg-body.jpg);
    color: #555555!important;
     margin-left: 16px;
     margin-right: 16px;
    margin-top: 16px;
     margin-bottom: 16px;
     font-size:24px;
     line-height: 70px;
  border-radius: 10px 10px 10px 10px;
  height: 70px;
  }
  #sm-menu  li a{
   color: white;
  text-decoration: none;
  font-size:24px;
  line-height:70px;
}
  #sm-menu ul{
    margin-top: 100px;
     color: #555555!important;
     padding:inherit;

  }
  .subTitle-row{
    width: 90%;
  }
 .card-contents{
  width: 90%;
  padding-top: 16px;
  padding-bottom: 36px;
}
.main {
  width: 100%;

}
.side {
  width: 100%;
}
.side img{
  width: 80%;
  margin-left: 10%;
}
.flexbox{
  height: 700px;
}
.mobile-br{
  display: block;
}
.main,
.side {
  padding: 0%;
}
.card-contents .title{
  display: table;
  background-color: #006600;
  font-size:24px;
  width: 90%;
  color: white;
  margin-left: 8px;
  margin-right: 8px;
  font-weight: bold;
}
.description{
   text-align: left;
  font-size:18px;
  color: #555555;
  margin-left: 16px;
  margin-right: 16px;
  line-height: 36px;
  font-weight: bold;
  }
     .subTitle-row{
  margin:0px auto;
}

}
</style>
<script>
import SubHeader from './common/SubHeader'

export default {
  name: 'app',
  components: {
    SubHeader
  },
  methods: {
    closeMenu: function () {
      document.getElementById('sm-menu').style.display = 'none'
      document.getElementById('sm-menu-icon').style.display = 'block'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Service.vue